(function ($) {

    $(document).ready(function () {

        if (window.location.search.length > 0) {
            loadProperties($("#properties-filter"), true);
        }

        $(".filters__range-input").on("mouseup", function () {
            loadProperties($(this).parents('.filters'), true);
        });

        $(".filters__multiselect-list-item").on("click", function () {
            loadProperties($(this).parents('.filters'), true);
        });

        $(".filters__item--search input").on("change", function () {
            loadProperties($(this).parents('.filters'), true);
        });

        $("#properties-load-more-button").on("click", function (e) {
            e.preventDefault();
            loadProperties($("#" + $(this).data("filter")), false);
        });

        function loadProperties(filterBar, reset = false) {
            var filters = {};

            var count = parseInt(filterBar.data("more"));
            var skip = reset ? 0 : parseInt(filterBar.data("count"));
            filterBar.data('count', skip + count);
            filters.count = count;
            filters.skip = skip;

            filters.floorareamin = parseInt(filterBar.find('.range-values--min').html());
            filters.floorareamax = parseInt(filterBar.find('.range-values--max').html());

            filterBar.find('.filters__multiselect-list').each(function () {
                var id = $(this).attr('id');
                var value = "";
                $(this).find('input[type=checkbox]:checked').each(function () {
                    value += $(this).attr('id') + ",";
                });
                filters[id] = value;
            });

            filters.search = filterBar.find('.filters__item--search input').val();

            $.ajax({
                url: '/umbraco/surface/Property/RenderPropertiesResults',
                type: 'GET',
                data: filters,
                success: function (response) {
                    var results = $('#properties-results');
                    if (reset) {
                        results.html(response);
                    } else {
                        results.find('.js-property-result:last').after(response);
                    }
                    if ($('#properties-results .js-results-data').data('more') == 'True') {
                        $('#properties-load-more-button').show();
                    } else {
                        $('#properties-load-more-button').hide();
                    }
                    $('#properties-results .js-results-data').remove();
                }
            });
            let locationsText = filters.locations.slice(0, -1).replaceAll(',', ', ');
            const words = locationsText.split(" ");

            if (locationsText == "" || locationsText == " " || words == undefined) {
                locationsText = "All Areas";
            } else {
                for (let i = 0; i < words.length; i++) {
                    words[i] = words[i][0].toUpperCase() + words[i].substr(1);
                }
    
                locationsText = words.join(" ");
            }

            let propertyTypesText = filters.propertytypes.slice(0, -1).replaceAll(',', ', ');
            if (propertyTypesText == "" || propertyTypesText == " ") {
                propertyTypesText = "All Types"
            }
            $('.js-button-filter-locations span').text(locationsText)
            $('.js-button-filter-property-types span').text(propertyTypesText)
        }

    })

})(jQuery);
